import { WebviewFunctions } from 'constants/common';
import { selectCurrentTeam, selectPaymentSystemConfig } from 'containers/app/appSlice';
import { selectAuthState } from 'containers/auth/authSlice';
import { PaymentSystem } from 'containers/payouts/constants';
import { useAppSelector } from 'hooks';
import { FC, useEffect } from 'react';
import { LocalStorage } from 'services/storage';
import { buildOnboardingIframeUrl } from 'services/nativeToken';
import { VoidFn } from 'types/baseTypes';

interface CollectPendingDocumentsProps {
  handleExit: VoidFn;
}

const CollectPendingDocuments: FC<CollectPendingDocumentsProps> = ({ handleExit }) => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { paymentSystem } = useAppSelector(selectPaymentSystemConfig);
  const { idToken, refreshToken } = useAppSelector(selectAuthState) ?? {};

  const getFrameURL = () => {
    return buildOnboardingIframeUrl({
      hashPath: '/ca-connect-pending-documents',
      params: {
        idToken: idToken || LocalStorage.get('idToken'),
        refreshToken: refreshToken || LocalStorage.get('refreshToken'),
        teamId: currentTeam?.id,
        paymentSystem: paymentSystem ?? PaymentSystem.CA
      }
    });
  };

  useEffect(() => {
    const handleReadMessage = event => {
      if (event.data === WebviewFunctions.CLOSE_WEBVIEW) {
        handleExit();
      }
    };
    window.addEventListener('message', handleReadMessage, false);
    return () => {
      window.removeEventListener('message', handleReadMessage, false);
    };
  }, []);

  return (
    <div className="h-full w-full">
      <iframe src={getFrameURL()} title="stripe-pending-doc" className="h-full w-full" />
    </div>
  );
};

export default CollectPendingDocuments;
